import { useState } from "react";
import content from "../data/content.json";
import "./PersonalSection.scss";
import "./HorizontalMenu.scss";
import HorizontalMenu from "../HorizontalMenu/HorizontalMenu";
import RefreshIcon from "@mui/icons-material/Refresh";
import { CircularProgress } from "@mui/material";

const PersonalSection = () => {
  const initialSrc = "https://random-xkcder.vercel.app/";

  const [imageUrl, setImageUrl] = useState(initialSrc);
  const [isLoading, setIsLoading] = useState(false);
  // Function to update the timestamp, triggering a re-render and cache bust
  const refreshImage = () => {
    setIsLoading(true);
    // A common technique to force a "revisit" or cache-bust is
    // to append a unique query parameter, like a timestamp.
    const newTimestamp = new Date().getTime();
    const newUrl = `${initialSrc}?timestamp=${newTimestamp}`;

    // Update the state to the new URL, triggering a re-render
    setImageUrl(newUrl);
  };

  return (
    <>
      <div className="my-interests container mt-4 mb-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8">
            <h2 className="my-interests-title mb-3">My Interests</h2>
            <HorizontalMenu
              className="personal-horizontal-menu"
              items={content.personalMenu}
              variant="personal"
            />
          </div>
        </div>
      </div>
      <div className="xkcd-bar">
        <div className="xkcd container mt-4 mb-4">
          <div className="row justify-content-center">
            <div className="xkcd-block-wrapper">
              <div className="xkcd-block">
                <div className="xkcd-header">
                  <div className="xkcd-title">XKCD Comic Generator</div>
                  <button
                    className="refresh-btn btn btn-outline-secondary ms-2"
                    onClick={refreshImage}
                  >
                    {isLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <RefreshIcon />
                    )}
                  </button>
                </div>
                <a
                  href="https://xkcd.com/license.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={imageUrl}
                    title="xkcd"
                    alt="Random XKCD comic"
                    onLoad={() => setIsLoading(false)}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalSection;
